import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function NotFoundPage() {
  return <div className="w-full min-h-screen bg-white flex flex-col" data-id="element-2613">
      <div className="flex-grow flex items-center justify-center px-6" data-id="element-2614">
        <div className="max-w-xl mx-auto text-center" data-id="element-2615">
          {/* Logo */}
          <div className="mb-12" data-id="element-2616">
            <img src="https://cdn.magicpatterns.com/uploads/u2RsmpFkExbV8oAVAJrtqh/Caveo-Lockup-FC.png" alt="Caveo Logo" className="h-10 md:h-14 mx-auto" data-id="element-2617" />
          </div>

          {/* 404 Number */}
          <div className="text-[120px] md:text-[160px] font-extrabold leading-none text-[#631bb7] opacity-10 select-none mb-[-30px] md:mb-[-40px]" data-id="element-2618">
            404
          </div>

          {/* Message */}
          <h1 className="text-3xl md:text-4xl font-extrabold text-[#111111] mb-4" data-id="element-2619">
            Page not found
          </h1>
          <p className="text-lg text-gray-500 leading-relaxed mb-8 max-w-md mx-auto" data-id="element-2620">
            The page you're looking for doesn't exist or has been moved. Let's
            get you back on track.
          </p>

          {/* CTA */}
          <Link to="/" className="inline-flex items-center bg-[#631bb7] text-white px-8 py-4 rounded-lg font-bold no-underline hover:bg-[#521099] transition-all shadow-md text-lg" data-id="element-2621">
            <ArrowLeftIcon size={20} className="mr-2" data-id="element-2622" />
            Back to Home
          </Link>
        </div>
      </div>

      {/* Footer */}
      <div className="py-6 text-center text-sm text-gray-400" data-id="element-2623">
        © 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.
      </div>
    </div>;
}